// action 类型定义
const ACTION_TYPE = {
  SET_FORM_DATA: 'PageCache/SET_FORM_DATA',
  RESET_FORM_DATA: 'PageCache/RESET_FORM_DATA',

  SET_MODULE_DATA: 'PageCache/SET_MODULE_DATA',
  DEL_MODULE_DATA: 'PageCache/DEL_MODULE_DATA',
  RESET_MODULE_DATA: 'PageCache/RESET_MODULE_DATA',
}

interface pageCache {
  // 缓存页面的searchForm数据
  searchFormValue: {
    [x: string]: {
      [x: string]: any
    }
  }
  pagekey: {
    key: string
    data: any
  }[]
}
// 默认数据
const defaultState: pageCache = {
  searchFormValue: {},
  pagekey: [],
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_FORM_DATA:
      arr.searchFormValue = { ...arr.searchFormValue, ...action.value }
      return arr
    case ACTION_TYPE.RESET_FORM_DATA:
      arr.searchFormValue = {}
      return arr
    case ACTION_TYPE.SET_MODULE_DATA:
      // 先过滤再添加
      const a = arr.pagekey.filter((item) => item.key !== action.value.key)
      arr.pagekey = [...a, ...[action.value]]
      return arr
    case ACTION_TYPE.DEL_MODULE_DATA:
      const b = arr.pagekey.filter((item) => item.key !== action.value)
      arr.pagekey = b
      return arr
    case ACTION_TYPE.RESET_MODULE_DATA:
      arr.pagekey = []
      return arr
    default:
      return state
  }
}
// Action Creators

// 设置formcache缓存
export const setPageFormCacheDataAction = (param: {
  [x: string]: { [x: string]: any }
}) => ({
  type: ACTION_TYPE.SET_FORM_DATA,
  value: param,
})

// 设置module 状态
export const setModuleDataAction = (param: { key: string; data: any }) => ({
  type: ACTION_TYPE.SET_MODULE_DATA,
  value: param,
})

// 删除module 状态
export const delModuleDataAction = (param: string) => ({
  type: ACTION_TYPE.DEL_MODULE_DATA,
  value: param,
})

// 重置所有模块状态
export const resetModuleDataAction = () => ({
  type: ACTION_TYPE.RESET_MODULE_DATA,
})

export const resetFormDataAction = () => ({
  type: ACTION_TYPE.RESET_FORM_DATA,
})
// action 类型定义
const ACTION_TYPE = {
  SET_FORM_DATA: 'PageCache/SET_FORM_DATA',
  RESET_FORM_DATA: 'PageCache/RESET_FORM_DATA',

  SET_MODULE_DATA: 'PageCache/SET_MODULE_DATA',
  DEL_MODULE_DATA: 'PageCache/DEL_MODULE_DATA',
  RESET_MODULE_DATA: 'PageCache/RESET_MODULE_DATA',
}

interface pageCache {
  // 缓存页面的searchForm数据
  searchFormValue: {
    [x: string]: {
      [x: string]: any
    }
  }
  pagekey: {
    key: string
    data: any
  }[]
}
// 默认数据
const defaultState: pageCache = {
  searchFormValue: {},
  pagekey: [],
}
interface Action {
  type: string
  value: any
}
// 默认 Reducer
export default function reducer(state = defaultState, action: Action) {
  const arr = { ...state }
  switch (action.type) {
    case ACTION_TYPE.SET_FORM_DATA:
      arr.searchFormValue = { ...arr.searchFormValue, ...action.value }
      return arr
    case ACTION_TYPE.RESET_FORM_DATA:
      arr.searchFormValue = {}
      return arr
    case ACTION_TYPE.SET_MODULE_DATA:
      // 先过滤再添加
      const a = arr.pagekey.filter((item) => item.key !== action.value.key)
      arr.pagekey = [...a, ...[action.value]]
      return arr
    case ACTION_TYPE.DEL_MODULE_DATA:
      const b = arr.pagekey.filter((item) => item.key !== action.value)
      arr.pagekey = b
      return arr
    case ACTION_TYPE.RESET_MODULE_DATA:
      arr.pagekey = []
      return arr
    default:
      return state
  }
}
// Action Creators

// 设置formcache缓存
export const setPageFormCacheDataAction = (param: {
  [x: string]: { [x: string]: any }
}) => ({
  type: ACTION_TYPE.SET_FORM_DATA,
  value: param,
})

// 设置module 状态
export const setModuleDataAction = (param: { key: string; data: any }) => ({
  type: ACTION_TYPE.SET_MODULE_DATA,
  value: param,
})

// 删除module 状态
export const delModuleDataAction = (param: string) => ({
  type: ACTION_TYPE.DEL_MODULE_DATA,
  value: param,
})

// 重置所有模块状态
export const resetModuleDataAction = () => ({
  type: ACTION_TYPE.RESET_MODULE_DATA,
})

export const resetFormDataAction = () => ({
  type: ACTION_TYPE.RESET_FORM_DATA,
})
